module.exports = __webpack_public_path__ + "static/media/PEC-actual.2e39b0d0.jpg";